import { ProbabilitiesTable } from "../Inspect/ProbabilitiesTable";
import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";

function Sample2028000() {
  const llmPredictions = {
    " show": 0.048629824072122574,
    " help": 0.04831456020474434,
    " estimate": 0.042142756283283234,
    " determine": 0.032001227140426636,
    " examine": 0.029885826632380486,
    " assess": 0.029848942533135414,
    " identify": 0.028705336153507233,
    " explore": 0.028437625616788864,
    " provide": 0.028300514444708824,
    " compare": 0.025674916803836823,
    " support": 0.02383621782064438,
    " inform": 0.017028754577040672,
    " better": 0.015868520364165306,
    " highlight": 0.014620953239500523,
    " shed": 0.014298900030553341,
    " analyze": 0.013830741867423058,
    " track": 0.01296342071145773,
    " demonstrate": 0.012688678689301014,
    " explain": 0.01226020697504282,
    " investigate": 0.011992349289357662,
  };
  const saePredictions = {
    " determine": 0.09865514934062958,
    " identify": 0.09515273571014404,
    " examine": 0.044355545192956924,
    " show": 0.04084845259785652,
    " estimate": 0.033802054822444916,
    " assess": 0.0298430435359478,
    " describe": 0.027850937098264694,
    " predict": 0.022244295105338097,
    " study": 0.020712025463581085,
    " better": 0.020545650273561478,
    " inform": 0.020044250413775444,
    " help": 0.019691048189997673,
    " analyze": 0.017618397250771523,
    " investigate": 0.017538951709866524,
    " compare": 0.016982125118374825,
    " explore": 0.013511702418327332,
    " suggest": 0.01275776606053114,
    " further": 0.01274851057678461,
    " find": 0.012406758964061737,
    " confirm": 0.012098904699087143,
  };

  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="mini" sampleId="2028000" />
        <span> - </span>
        <SampleQuote text="uses SEER data to quantify" targetIdx={14} targetLength={3} />
      </h4>
      <p>
        This circuit predicts that the next token will be a verb describing the usage of data.
        Feature <FeatureAnchor modelId="mini" sampleId="2028000" featureKey="0.8.6133" compact />{" "}
        responds to the pattern “used to” or “used __ to”, constraining the next word in a sequence
        to verbs. Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2028000" featureKey="0.8.10236" compact /> responds
        to phrases related to the analysis of data, further narrowing the list of possible next
        tokens to those describing how data may be used.
      </p>
      <div className="figures">
        <figure>
          <figcaption>LLM Prediction</figcaption>
          <ProbabilitiesTable probabilities={llmPredictions} limit={5} />
          <p className="description">
            Most likely tokens representing verbs that describe how data may be used
          </p>
        </figure>
        <figure>
          <figcaption>Reconstructed Prediction</figcaption>
          <ProbabilitiesTable probabilities={saePredictions} limit={5} />
          <p className="description">
            Most likely tokens after using SAE features in the last layer to reconstruct the
            residual stream
          </p>
        </figure>
      </div>
    </section>
  );
}

export { Sample2028000 };
